import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid'

import Notifier, { openSnackbar } from '../components/notifier';
import api from '../api/backend'

import ReactGA from 'react-ga';

import { isBrowser } from "react-device-detect";

const styles = theme => ({
    layout: {
        height: '100vh',
        display: 'block', // Fix IE11 issue.
        // marginLeft: theme.spacing.unit * 3,
        // marginRight: theme.spacing.unit * 3,
        [theme.breakpoints.up(600 + theme.spacing.unit * 3 * 2)]: {
            width: '100%',
            marginLeft: 'auto',
            marginRight: 'auto',
        },
        paddingTop: 64,
        backgroundColor: '#f8982b'
    },
    paper: {
        marginLeft: 'calc(50% - 300px)',
        maxWidth: 600,
        marginTop: theme.spacing.unit * 8,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
        // borderRadius: 0,
    },
    paperMobile: {
        maxWidth: 600,
        marginTop: theme.spacing.unit * 8,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
        // borderRadius: 0,
    },
    avatar: {
        margin: theme.spacing.unit,
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE11 issue.
        marginTop: theme.spacing.unit,
    },
    submit: {
        marginTop: theme.spacing.unit * 3,
    },
});

class Register extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = { email: '', password: '', loading: false }
    }

    componentDidMount() {
        ReactGA.initialize('UA-141674580-1');
        ReactGA.pageview('Register');
    }

    handleSubmit = (event) => {
        event.preventDefault();
        this.setState({ loading: true })
        const { email, password, firstName, lastName, nickName, tel, address, parentName, parentContract } = this.state
        ReactGA.event({
            category: 'Register',
            action: `Register with [${email}]`
          })
        api.register({ userName: email, email, password, firstName, lastName, nickName, tel, address, parentName, parentContract }).then(([response, json]) => {
            if (response.status === 200) {
                openSnackbar({ message: 'ลงทะเบียนสำเร็จ กรุณารอการอนุมัติจากทางสถาบัน' })
                setTimeout(() => {
                    this.setState({ loading: false })
                    this.props.history.push('/')
                }, 5000);
            } else if (response.status === 500) {
                openSnackbar({ message: json.message })
                this.setState({ loading: false })
            } else {
                this.setState({ loading: false })
            }
        }).catch(() => {
            console.error('ลงทะเบียนไม่สำเร็จกรุณาลองใหม่อีกครั้ง')
            this.setState({ loading: false })
        })
    }

    validateEmail(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    validateNumber(number) {
        var re = /^[0-9]+$/;
        return re.test(String(number).toLowerCase());
    }

    validate = () => {
        const { email, password, confirmPassword, firstName, lastName, nickName, tel, address, parentName, parentContract } = this.state
        if(!this.validateEmail(email)) {
            return false;
        } else if((password !== confirmPassword) || (password.length < 4 && confirmPassword < 4)) {
            return false;
        } else if(firstName === undefined || firstName.length < 1) {
            return false;
        } else if(lastName === undefined || lastName.length < 1) {
            return false;
        } else if(nickName === undefined || nickName.length < 1) {
            return false;
        } else if(!this.validateNumber(tel)) {
            return false;
        } else if(address === undefined || address.length < 1) {
            return false;
        } else {
            return true;
        }
    }

    render() {
        const { classes } = this.props
        return (
            <React.Fragment>
                <CssBaseline />
                <main className={classes.layout}>
                    <Notifier />
                        <Paper className={isBrowser ? classes.paper : classes.paperMobile}>
                            {/* <Avatar className={classes.avatar}>
                            <LockIcon />
                        </Avatar> */}
                            <Typography variant="headline">ลงชื่อเข้าใช้งาน</Typography>
                            <form className={classes.form} onSubmit={this.handleSubmit}>
                                <Grid container spacing={24} >
                                    <Grid item xs={12}>
                                        <InputLabel htmlFor="email" required>อีเมลล์ (UserName)</InputLabel>
                                        <Input id="email" name="email" autoComplete="email" autoFocus
                                            fullWidth
                                            onChange={(e) => {
                                                this.setState({ email: e.target.value })
                                            }} />
                                    </Grid>
                                    <Grid item xs={isBrowser ? 6 : 12}>
                                        <InputLabel htmlFor="password" required>รหัสเข้าใช้งาน</InputLabel>
                                        <Input
                                            name="password"
                                            type="password"
                                            id="password"
                                            autoComplete="current-password"
                                            fullWidth
                                            onChange={(e) => {
                                                this.setState({ password: e.target.value })
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={isBrowser ? 6 : 12}>
                                        <InputLabel htmlFor="password" required>ยื่นยันรหัสเข้าใช้งาน</InputLabel>
                                        <Input
                                            name="confirmPassword"
                                            type="password"
                                            id="confirmPassword"
                                            autoComplete="current-confirmPassword"
                                            fullWidth
                                            onChange={(e) => {
                                                this.setState({ confirmPassword: e.target.value })
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={isBrowser ? 6 : 12}>
                                        <InputLabel htmlFor="firstName" required>ชื่อ</InputLabel>
                                        <Input id="firstName" name="firstName" autoComplete="firstName" fullWidth autoFocus
                                            onChange={(e) => {
                                                this.setState({ firstName: e.target.value })
                                            }} />
                                    </Grid>
                                    <Grid item xs={isBrowser ? 6 : 12}>
                                        <InputLabel htmlFor="lastName" required>นามสกุล</InputLabel>
                                        <Input id="lastName" name="lastName" autoComplete="lastName" fullWidth autoFocus
                                            onChange={(e) => {
                                                this.setState({ lastName: e.target.value })
                                            }} />
                                    </Grid>
                                    <Grid item xs={isBrowser ? 6 : 12}>
                                        <InputLabel htmlFor="nickName" required>ชื่อเล่น</InputLabel>
                                        <Input id="nickName" name="nickName" autoComplete="nickName" fullWidth autoFocus
                                            onChange={(e) => {
                                                this.setState({ nickName: e.target.value })
                                            }} />
                                    </Grid>
                                    <Grid item xs={isBrowser ? 6 : 12}>
                                        <InputLabel htmlFor="tel" required>เบอร์โทรศัพท์</InputLabel>
                                        <Input id="tel" name="tel" autoComplete="tel" fullWidth autoFocus
                                            onChange={(e) => {
                                                this.setState({ tel: e.target.value })
                                            }} />
                                    </Grid>
                                    <Grid item xs={isBrowser ? 6 : 12}>
                                        <InputLabel htmlFor="parentName" required>ชื่อผู้ปกครอง</InputLabel>
                                        <Input id="parentName" name="parentName" autoComplete="parentName" fullWidth autoFocus
                                            onChange={(e) => {
                                                this.setState({ parentName: e.target.value })
                                            }} />
                                    </Grid>
                                    <Grid item xs={isBrowser ? 6 : 12}>
                                        <InputLabel htmlFor="parentContract" required>เบอร์ติดต่อผู้ปกครอง</InputLabel>
                                        <Input id="parentContract" name="parentContract" autoComplete="parentContract" fullWidth autoFocus
                                            onChange={(e) => {
                                                this.setState({ parentContract: e.target.value })
                                            }} />
                                    </Grid>
                                    {/* <Grid item xs={12}>
                                    <InputLabel htmlFor="demo-controlled-open-select">ประเภทนักเรียน</InputLabel>
                                    <Select
                                        value={this.state.role}
                                        onChange={(event) => { this.setState({ role: event.target.value }) }}
                                        inputProps={{
                                            name: 'role',
                                            id: 'role-simple',
                                        }}
                                        fullWidth
                                    >
                                        <MenuItem value="เรียนออนไลน์">เรียนออนไลน์</MenuItem>
                                        <MenuItem value="เรียนออนไลน์ + เรียนสด">เรียนออนไลน์ + เรียนสด</MenuItem>
                                    </Select>
                                </Grid> */}
                                    <Grid item xs={12}>
                                        <InputLabel htmlFor="address" required>ที่อยู่</InputLabel>
                                        <TextField
                                            required
                                            id="address"
                                            name="address"
                                            fullWidth
                                            multiline
                                            rows={6}
                                            onChange={(event) => { this.setState({ address: event.target.value }) }}
                                        />
                                    </Grid>
                                </Grid>
                                <Button
                                    type="submit"
                                    fullWidth
                                    variant="raised"
                                    color="primary"
                                    className={classes.submit}
                                    disabled={this.state.loading || !this.validate()}
                                >
                                    สมัครเข้าใช้งาน
                            </Button>
                            <Button
                                fullWidth
                                variant="raised"
                                color="default"
                                className={classes.submit}
                                onClick={() => {
                                    this.props.history.push('/login')
                                }}
                            >
                                ลงชื่อเข้าใช้
            </Button>
                            </form>
                        </Paper>
                </main>
            </React.Fragment>
        );
    }
}

export default withStyles(styles)(Register);